<template>
  <div class="foret-pwd" :style="{height:screenHeight}">
    <!--导航条-->
    <!--导航条-->
    <van-icon @click="$router.go(-1)" class="go-back" name="arrow-left" />
    <div class="login-top">
      <div class="login-text">
        <span>找回密码
        </span>
        <div class="line"></div>
      </div>
      <div class="login-icon"></div>
    </div>

    <van-row>
      <van-col class="colLeft" span="2">
        <van-icon class="iconfont" class-prefix='icon' name='shouji1' style="font-size: 20px" />
      </van-col>
      <van-col class="colRight" span="22">
        <van-field v-model="data.mobile" type="number" placeholder="输入手机号码" />
      </van-col>
    </van-row>

    <van-row>
      <van-col class="colLeft" span="2">
        <van-icon class="iconfont" class-prefix='icon' name='yanzhengma2' style="font-size: 20px" />
      </van-col>
      <van-col class="colRight" span="22">
        <van-field v-model="data.msgCode" center clearable placeholder="请输入短信验证码">
          <template #button>
            <van-button size="small" color="#D6BE93" @click="getCodeEv" v-if="getCode" type="primary">获取验证码</van-button>
            <div class="has-get-code" v-else>{{count}}秒后重发</div>
          </template>
        </van-field>
      </van-col>
    </van-row>

    <van-row>
      <van-col class="colLeft" span="2">
        <van-icon class="iconfont" class-prefix='icon' name='mima' style="font-size: 20px" />
      </van-col>
      <van-col class="colRight" span="18">
        <van-field v-model="data.pw" :type="isPwd" placeholder="请输入登录密码" />
      </van-col>
      <van-col class="colBottom" span="4">
        <van-icon class="iconfont" class-prefix='icon' @click="isPwd == 'password' ? isPwd = 'text':isPwd = 'password'" name='yanjing' style="font-size: 20px;" />
      </van-col>
    </van-row>

    <van-row>
      <van-col class="colLeft" span="2">
        <van-icon class="iconfont" class-prefix='icon' name='mima' style="font-size: 20px" />
      </van-col>
      <van-col class="colRight" span="18">
        <van-field v-model="data.repw" :type="isRepwd" placeholder="请再次输入登录密码" />
      </van-col>
      <van-col class="colBottom" span="4">
        <van-icon class="iconfont" class-prefix='icon' @click="isRepwd == 'password' ? isRepwd = 'text':isRepwd = 'password'" name='yanjing' style="font-size: 20px;" />
      </van-col>
    </van-row>

    <van-button type="primary" class="sub-btn" @click="onSubmit" size="large">登录</van-button>
  </div>
</template>

<script>
import navigation from "../../components/navigation";
import { authRegCaptcha, userResetPW } from "@/api/index";
import { Dialog } from "vant";

export default {
  name: "forgetPwd",
  components: {
    navigation
  },
  data() {
    return {
      screenHeight: "",
      isPwd: "password",
      isRepwd: "password",
      data: {
        mobile: "", //账号
        msgCode: "", //验证码
        uuid: "",
        pw: "", //新密码
        repw: "" //新密码
      },
      getCode: true,
      timer: null,
      count: ""
    };
  },
  mounted() {
    window.addEventListener("resize", function() {
      this.screenHeight = document.body.clientHeight + "px";
    });
  },
  methods: {
    onSubmit() {
      if (
        this.data.mobile == "" ||
        this.data.msgCode == "" ||
        this.data.pw == "" ||
        this.data.repw == ""
      ) {
        Dialog.alert({
          title: "提示",
          message: "请填写正确填写数据"
        });
        return;
      }
      if (this.data.pw != this.data.repw) {
        Dialog.alert({
          title: "提示",
          message: "密码不一致"
        });
        return;
      }
      console.log(this.data);
      userResetPW(this.data).then(res => {
        console.log(res);
        if (res.data.errno == 0) {
          this.$router.go(-1);
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg
          });
        }
      });
    },
    getCodeEv() {
      if (/^1[3456789]\d{9}$/.test(this.data.mobile)) {
        let mobile = {
          mobile: this.data.mobile
        };
        authRegCaptcha(mobile).then(res => {
          console.log(res);
          if (res.data.return_code == 0) {
            this.data.uuid = res.data.data.uuid;
            this.getCode = false;
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.getCode = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          } else {
            Dialog.alert({
              message: res.data.return_message
            }).then(() => {
              // on close
            });
          }
        });
      } else {
        Dialog.alert({
          title: "提示",
          message: "手机号格式错误"
        }).then(() => {
          // on close
        });
      }
    }
  }
};
</script>



<style lang="scss" scoped>
.foret-pwd {
  height: 100%;
  width: 100%;
  margin: 0 auto;
  overflow-y: scroll;

  background: #fff;
  .login-top {
    display: flex;
    justify-content: space-between;
    margin: 2.2rem auto 4rem;
    width: 90%;
    .login-text {
      font-size: 1.75rem;
      font-weight: bold;
      display: flex;
      text-align: left;
      flex-direction: column;
      .line {
        background: #222b45;
        border-radius: 2.5px;
        width: 3.1rem;
        height: 0.5rem;
        margin-top: 1.2rem;
      }
      span {
        font-family: PingFangSC-Medium;
        font-size: 2.8rem;
        color: #222b45;
        line-height: 4rem;
      }
    }
    .login-icon {
      width: 6.8rem;
      height: 6.8rem;
      background: url("../../assets/index/logo_img.png") center center no-repeat;
      background-color: #d6be93;
      // border: 0.875rem solid #8f9bb3;
      border-radius: 50%;
      opacity: 0.5;
      box-sizing: border-box;
    }
  }
  .set-pwd-text {
    width: 89.5%;
    margin: 3.2rem auto 4.6rem;
    font-family: PingFangSC-Medium;
    font-size: 2.8rem;
    color: #424242;
    line-height: 3.6rem;
    text-align: left;
  }
  /deep/ .van-cell {
    // padding-top: 0;
    // padding-bottom: 0;
    padding: 0;
    // padding-left: 1rem;
    width: 97.5%;
    margin: 0 auto;
    padding-left: 4%;
    box-sizing: border-box;
  }
  .phone-text {
    width: 89.5%;
    margin: 0 auto;
    font-family: Rubik-Regular;
    font-size: 13px;
    color: #424242;
    line-height: 16px;
    text-align: left;
    margin-bottom: 0.3rem;
  }
  .has-get-code {
    width: 89.5%;
    margin: 0 auto;
    opacity: 0.2;
    background: rgba(44, 44, 57, 0.2);
    border: 0 solid rgba(20, 20, 20, 0.4);
    border-radius: 4px;
    font-family: PingFangSC-Regular;
    font-size: 1.2rem;
    color: #141414;
    letter-spacing: 0;
    /*height: 2.1rem;*/
    /*line-height: 2.1rem;*/

    height: 3rem;
    line-height: 2.9rem;

    text-align: center;
    width: 7.2rem;
  }
  .sub-btn {
    background: #d6be93;
    border-radius: 24px;
    height: 4rem;
    width: 89.3%;
    font-family: PingFangSC-Regular;
    font-size: 1.6rem;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    line-height: 4rem;
    border: 0;
    margin-top: 5.8rem;
  }
}
/deep/ .van-button--primary {
  background-color: #d6be93;
  border: 1px solid #d6be93;
}
/deep/ .van-row {
  border-bottom: 1px solid #c2c2c2;
  width: 90%;
  overflow: hidden;
  height: 6.8rem;
  display: flex;
  align-items: flex-end;
  margin: 0 auto;
  box-sizing: border-box;
  padding-bottom: 0.4rem;
}
/deep/ .icon-shouji1,
.icon-yanzhengma2,
.icon-mima {
  font-weight: 600;
  font-size: 2.7rem !important;
}
.go-back {
  display: inline-block;
  width: 100%;
  text-align: left;
  font-size: 2.4rem;
  margin: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/view/pages/forgetPwd.vue